import React, { useState } from 'react';
import { Lightbox } from 'react-modal-image';
import { Table } from 'reactstrap';

function AcceptedIssuesHistory(props) {
    const [showEvidence, setShowEvidence] = useState(false);

    const getStatus = (status) => {
        const color = status ? '#2AA60E' : '#DD4929';
        const text = status ? 'Accepted' : 'Unaccepted';

        return <span style={{ color: color }}>{text}</span>;
    };

    const getEvidence = (url) => {
        
        if(url) {
            return <div style={{fontSize: '25px'}}>
                <i className="icon-folder_open pointer" onClick={() => setShowEvidence(true)} data-testid="remove-row" />
                {showEvidence && 
                    <Lightbox
                        large={url}
                        alt="Evidence"
                        onClose={() => setShowEvidence(false)}
                    />
                }
            </div>
        }

        return <span></span>;
    };

    return (
        <div style={{ borderTop: '1px solid #D5D9DE', padding: '1rem 0' }}>
            <div className="title">
                <h6>Issue Acceptance History</h6>
            </div>
            <Table responsive striped hover>
                <thead>
                    <tr>
                        <th>
                            <a className="text-gray">Date</a>
                        </th>
                        <th>
                            <a className="text-gray">Status</a>
                        </th>
                        <th>
                            <a className="text-gray">Changed by</a>
                        </th>
                        <th>
                            <a className="text-gray">Reason</a>
                        </th>
                        <th>
                            <a className="text-gray">Evidence</a>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {props.acceptedIssues.map((item, index) => {
                        /**
                         * acceptedIssueHistory = [accepted, accepted_user, reason, entry_date]
                         */
                        return (
                            <tr key={index}>
                                <td style={{ color: '#6c757d', width: '7rem' }}>{item[3]}</td>
                                <td>{getStatus(item[0])}</td>
                                <td style={{ color: '#6c757d' }}>{item[1]}</td>
                                <td style={{ color: '#6c757d' }}>{item[2]}</td>
                                <td style={{ color: '#6c757d' }}>
                                    {getEvidence(item[4])}
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </Table>{' '}
        </div>
    );
}

export default React.memo(AcceptedIssuesHistory);
